module.exports = __webpack_public_path__ + "static/media/snackbar_v2_warning.40c8cc4e.svg";